// workout-slider
$('.workout-slider').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  dots: true,
  arrows: false,
  verticalSwiping: true,
  vertical: true,
  autoplay: true,
  responsive: [
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        adaptiveHeight: true,
      },
    },
    {
      breakpoint: 600,
      settings: {       
        verticalSwiping: false,
        vertical: false
      },
    },
  ],
});
	
// review-slider
$('.review-slider').slick({
  slidesToShow: 3,
  slidesToScroll: 1,
  arrows: true,
   prevArrow:"<button type='button' class='slick-prev pull-left'><i class='fa fa-chevron-left'></i></button>",
  nextArrow:"<button type='button' class='slick-next pull-right'><i class='fa fa-chevron-right'></i></button>",
  responsive: [
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        adaptiveHeight: true,
      },
    },
    {
      breakpoint: 600,
      settings: {
        arrows: true,
        dots: false,
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
});

// main-slider
$('.slider-body').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  dots: true,
  arrows: false
});
    
// Product Slideer
$(function() {
  $('.product__gallery').slick({
    slidesToShow: 1,
	slidesToScroll: 1,
    mobileFirst: true,
    arrows: false,
    adaptiveHeight: true,
    dots: true,
    responsive: [
      {
        breakpoint: 767,
        settings: 'unslick'
      }
    ]
  });
  $(window).on('resize', function() {
    $('.product__gallery').slick('resize');
  });
});
    
//  Footer Accordian
var responsiveflag = false;
jQuery(document).ready(function () {
    responsiveResize();
    jQuery(window).resize(responsiveResize);
});
function responsiveResize()
{
    if (jQuery(window).width() <= 767 && responsiveflag == false)
    {
        accordion('enable');
        responsiveflag = true;
    }
    else if (jQuery(window).width() >= 768)
    {
        accordion('disable');
        responsiveflag = false;
    }
}
function accordion(status)
{
    if(status == 'enable')
    {
        var accordion_selector = '.footer-link h4';
        jQuery(accordion_selector).on('click', function(e){
            jQuery(this).toggleClass('active').next().stop().slideToggle('medium');
            e.preventDefault();
        });
        jQuery(accordion_selector).next().slideUp('fast');
    }
    else
    {
        jQuery('.footer-link h4').removeClass('active').off().next().removeAttr('style').slideDown('fast');
    }
}    